<template>
  <!-- 基本担保履约资金帐户日报表 -->
  <div>
    <div class="report_title">
      <label class="report-line" />
      <span class="report-title">基本担保履约资金帐户日报表</span>
      <exportConfig
        :all-head="allHead"
        :header-name="headerName"
      />
    </div>
    <el-table :data="tableData">
      <el-table-column
        fixed
        label="序号"
        align="center"
        width="70px"
      >
        <template slot-scope="scope">
          {{ scope.$index+1 }}
        </template>
      </el-table-column>
      <af-table-column
        fixed
        prop="summary"
        label="摘 要"
      />
      <af-table-column
        fixed
        prop="debitAmount"
        label="借方(转出)金额"
      />
      <af-table-column
        fixed
        prop="creditAmount"
        label="贷方(转入)金额"
      />
      <af-table-column
        prop="direction"
        label="方向"
      />
      <af-table-column
        prop="balance"
        label="余额"
      />
    </el-table>
    <MoreData
      :all-data="allData"
      :table-data.sync="tableData"
    />
  </div>
</template>

<script>
import api from '@/api'
import MoreData from '@/components/more-data'
import exportConfig from '@/components/exportConfig'

export default {
  name: 'DailyStatementOfCapitalAccount',
  components: {
    MoreData,
    exportConfig,
  },
  props: {
    query: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      allHead: [{
        fieldLabel: '摘 要',
        excelColumn: 'summary'
      },
      {
        fieldLabel: '借方(转出)金额',
        excelColumn: 'debitAmount'
      },
      {
        fieldLabel: '贷方(转入)金额',
        excelColumn: 'creditAmount'
      },
      {
        fieldLabel: '方向',
        excelColumn: 'direction'
      },
      {
        fieldLabel: '余额',
        excelColumn: 'balance'
      },
      ],
      currentPage: 1,
      total: 0,
      pageSize: 10,

      tableData: [], // 表格数据
      allData: [],
      headerName: '购销计划一览表_基本担保履约资金帐户日报表',
    }
  },
  methods: {
    // 分页查询
    async fetchList (currentPage, pageSize) {
      if (pageSize) {
        this.pageSize = pageSize
      }
      this.currentPage = currentPage || this.currentPage || 1
      let param = {
        ...this.query,
        currentPage: this.currentPage,
        pageSize: this.pageSize
      }
      param.queryType = '2' // 历史【必选，1当日2历史】
      param.transDate = param.date ? this.$dayjs(this.query.date).format('YYYYMMDD') : '000000'
      let res = await api.spotPurchaseSaleInquiry.DailyStatementOfCapitalAccount(param)
      this.allData = res.data || []
    },
  }
}

</script>
